import React, { useEffect } from "react";

const FirstStep = ({ data }) => {
  useEffect(() => {
    function launchAppOnDevice() {
      let currentUrl = window.location.href;
      const url = currentUrl.replace(window.location.origin + "/", process.env.REACT_APP_MOBILE);
      window.location.replace(url);
    }

    launchAppOnDevice();
  }, []);

  return <div className="FirstStep"></div>;
};
export default FirstStep;
